module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.dependants), function(dependant, index) {
    return _c('div', {
      staticClass: "dependant"
    }, [_c('dependant', {
      attrs: {
        "index": index,
        "stepValid": _vm.isValid()
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-8"
  }, [_c('button', {
    staticClass: "a-button u-margin-top-0 u-margin-bottom-0",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add Dependant")])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a864792!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/TheDependants.vue
// module id = 1754
// module chunks = 0